import { create } from 'zustand';

interface OrderProductsReloadSignal {
  version: number;
  isFromRachel: boolean;
}

interface RequestOrderProductsReloadOptions {
  isFromRachel?: boolean;
}

interface OrderProductsReloadStore {
  reloadSignals: Record<string, OrderProductsReloadSignal>;
  requestReload: (orderId: string, options?: RequestOrderProductsReloadOptions) => void;
}

const useOrderProductsReloadStore = create<OrderProductsReloadStore>((set) => ({
  reloadSignals: {},
  requestReload: (orderId, { isFromRachel = false } = {}) =>
    set((state) => ({
      reloadSignals: {
        ...state.reloadSignals,
        [orderId]: { version: (state.reloadSignals[orderId]?.version ?? 0) + 1, isFromRachel },
      },
    })),
}));

export default useOrderProductsReloadStore;
